import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router';
import { logout } from '../core/services/authService';
import { LOGOUT } from '../core/store/slice/authSlice';
import { useDispatch } from 'react-redux';
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default function LogoutExpiredModal({ setLogOutModal, logOutModal }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    return (
        <React.Fragment>
            <BootstrapDialog aria-labelledby="customized-dialog-title" open={logOutModal}>
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Logout
                </DialogTitle>

                {/* <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton> */}
                <DialogContent dividers>
                    <Typography gutterBottom style={{ fontWeight: '500', textAlign: 'center' }}>
                        You have been logged out of the application, please login again to use the application.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        color="error"
                        autoFocus
                        onClick={() => {
                            dispatch(LOGOUT());
                            localStorage.clear();
                            sessionStorage.clear();
                            setLogOutModal(false);
                            setTimeout(() => {
                                navigate('/');
                            }, [600]);
                        }}
                    >
                        Logout
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    );
}
